import React from 'react';
import { Calendar, Plus } from 'lucide-react';

const EventsHeader = ({ onCreateEvent, userRole }) => {
  return (
    <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-10">
      {/* Title Section */}
      <div className="flex items-center gap-4">
        <div className="relative">
          <div className="absolute inset-0 bg-blue-600 rounded-2xl blur-md opacity-20"></div>
          <div className="relative p-3 bg-blue-600 rounded-2xl shadow-lg">
            <Calendar size={28} className="text-white" />
          </div>
        </div>
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 tracking-tight">
            Events
          </h1>
          <p className="text-gray-500 text-sm lg:text-base mt-0.5">
            Manage and track all your events
          </p>
        </div>
      </div>
      {/* Create Button */}
      {userRole =="Administrator" &&<button
        onClick={onCreateEvent}
        className="group inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl active:scale-95"
      >
        <Plus size={20} className="group-hover:rotate-90 transition-transform duration-200" />
        Create Event
      </button>}
    </div>
  );
};

export default EventsHeader;